import { render, staticRenderFns } from "./EditPermission.vue?vue&type=template&id=cdfc6af8&scoped=true&"
import script from "./EditPermission.vue?vue&type=script&lang=js&"
export * from "./EditPermission.vue?vue&type=script&lang=js&"
import style0 from "./EditPermission.vue?vue&type=style&index=0&id=cdfc6af8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfc6af8",
  null
  
)

export default component.exports